import React from 'react';
import PropTypes from 'prop-types';
import lpad from 'underscore.string/lpad';
import Button from '../../../fragments/button';
import Dialog from '../../../fragments/dialog';
import {FormHorizental, TextArea} from '../../../fragments/forms';

import {getAccessionNumberByPopSet} from './genbank-api';

import style from './style.css';

import {dialog_context} from '../../../fragments/dialog';

const ACCESSION_REGEX = /^([A-Z\d_]+)$/;
const POPSET_REGX = /^\d+$/;
const ACCESSION_RANGE_REGEX = /^([A-Z]+)(\d+)$/;
const ACCESSION_IGNORE_TEXT_REGEX = /\[accn\]| and |\.\d?/gi;
const RANGE_SEPARATOR_REGEX = new RegExp('\\s*[:\u2013\u2014-]+\\s*', 'g');
const ACCESSION_DELIMITER_REGEX = /[,;\s]+/g;

function genbankRangeToIDs(rangeText) {
  const result = [];
  const [start, end] = rangeText.split('-', 2);
  if (!ACCESSION_REGEX.test(start) || !ACCESSION_REGEX.test(end)) {
    throw new Error(`Invalid accession number range: ${rangeText}`);
  }
  let [, startAlpha, startNum] = ACCESSION_RANGE_REGEX.exec(start);
  let [, endAlpha, endNum] = ACCESSION_RANGE_REGEX.exec(end);
  const startNumLen = startNum.length;
  const endNumLen = endNum.length;
  startNum = parseInt(startNum, 10);
  endNum = parseInt(endNum, 10);
  if (startAlpha != endAlpha ||
      startNum > endNum ||
      startNumLen != endNumLen) {
    throw new Error(`Invalid accession number range: ${rangeText}`);
  }
  for (let i = startNum; i <= endNum; i ++) {
    result.push(`${startAlpha}${lpad(i.toString(), startNumLen, '0')}`);
  }
  return result;
}


class GenbankForm extends React.Component {

  static propTypes = {
    onSubmit: PropTypes.func.isRequired
  };

  static contextType = dialog_context;

  // static contextTypes = {
  //   closeDialog: PropTypes.func.isRequired
  // };

  constructor() {
    super(...arguments);
    this.state = {genbankIDs: ''};
  }

  handleChange(genbankIDs) {
    this.setState({genbankIDs});
  }

  async handleSubmit(e) {
    e && e.preventDefault();
    let genbankIDs = this.refs.textArea.props.value;
    genbankIDs = genbankIDs.replace(ACCESSION_IGNORE_TEXT_REGEX, ' ');
    genbankIDs = genbankIDs.trim().toUpperCase();
    genbankIDs = genbankIDs.replace(RANGE_SEPARATOR_REGEX, '-');
    genbankIDs = genbankIDs.split(ACCESSION_DELIMITER_REGEX);
    let expandedGenbankIDs = [];
    let expandedPopSetIDs = [];
    for (let gid of genbankIDs) {
      gid = gid.trim();
      if (gid.length == 0) {
        continue;
      }
      if (gid.indexOf('-') > -1) {
        try {
          expandedGenbankIDs =
            expandedGenbankIDs.concat(genbankRangeToIDs(gid));
        } catch (e) {
          alert(e.message);
          return;
        }
      }
      else if (POPSET_REGX.test(genbankIDs)) {
        const popsetIDs = await getAccessionNumberByPopSet(genbankIDs);
        expandedPopSetIDs =
          expandedPopSetIDs.concat(popsetIDs);
      }
      else if (!ACCESSION_REGEX.test(gid)) {
        alert(`Invalid accession number: ${gid}`);
        return;
      }
      else {
        expandedGenbankIDs.push(gid);
      }
    }
    expandedGenbankIDs = Array.from(new Set(expandedGenbankIDs));
    expandedPopSetIDs = Array.from(new Set(expandedPopSetIDs));
    this.props.onSubmit(expandedGenbankIDs, expandedPopSetIDs);
    // this.context.closeDialog();
  }

  render() {
    const {genbankIDs} = this.state;

    return <div>
      <h2>Add Genbank Sequence(s)</h2>
      <p>
        Additional Genbank Sequence(s) can be added to the list by input
        the accession number(s) here.
      </p>
      <p>
        Support formats:
      </p>
      <ul>
        <li>
          Popset numbers separated by comma / line break / space: 123456789, 123456
        </li>
        <li>Accession number range: XX123456-XX123567</li>
        <li>
          Accession numbers separated by comma / line break / space:
          XX000001, XX000002, XX000003, ...
        </li>
      </ul>
      <FormHorizental onSubmit={this.handleSubmit.bind(this)}>
        <TextArea
         className={style.textarea}
         ref="textArea"
         name="genbankIDs"
         label="Genbank IDs"
         rows={4}
         maxRows={10}
         value={genbankIDs}
         placeholder={'XX123456-XX1234567\nXX000001, XX000002\nXX000003'}
         onChange={this.handleChange.bind(this)} />
        <Button
         type="submit" btnStyle="primary">
          Add
        </Button>
      </FormHorizental>
    </div>;
  }
}


export default class GenbankButton extends React.Component {

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired
  };

  static defaultProps = {
    disabled: false
  };

  constructor() {
    super(...arguments);
    this.state = {displayDialog: false};
  }


  handleClick(e) {
    e && e.preventDefault();
    this.setState({displayDialog: true});
  }

  closeDialog() {
    this.setState({displayDialog: false});
  }

  render() {
    const {disabled} = this.props;
    const {displayDialog} = this.state;

    return (
      <span className={style.genbankBtn}>
        <Button
         onClick={this.handleClick.bind(this)}
         disabled={disabled || displayDialog}>
          Genbank Number(s)
        </Button>
        {
        displayDialog ?
          <Dialog
           onClose={this.closeDialog.bind(this)}
           width="42rem" closeOnBlur={false}>
            <GenbankForm onSubmit={this.props.onChange} />
          </Dialog> : null
        }
      </span>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/genbank/genbank-button.js